export enum WebsiteLocale {
    TRADITIONAL_CHINESE = 'TradChn',
    SIMPLIFIED_CHINESE = 'SimpChn',
    ENGLISH = 'Eng',
}
